import { euros, type Article } from "./articles";
import { useLocale, useT } from "../settings/context";

/**
 * LE PRIX D'UN ARTICLE TEL QU'UNE BILLETTERIE L'ÉCRIT : « 900,00 € HT · TVA 10 % ».
 *
 * ⚠️ PARTAGÉ PAR LES DEUX BILLETTERIES, et c'est sa raison d'être. Celle du porteur
 * (`routes/Articles.tsx`) disait le taux ; celle d'un accompagnant
 * (`funnel/CompanionSteps.tsx`) n'écrivait que le HT pour les mêmes articles
 * (bug #236). Une seule ligne, deux écrans : ils ne peuvent plus diverger.
 *
 * Le prix HT, comme la V1 l'écrit : c'est ce que porte la colonne `price`, et le
 * récapitulatif donne le TTC. Le taux ne se dit que s'il y en a un : un article à 0 %
 * n'a aucune mention.
 */
export function ArticlePrice({ article }: { article: Article }) {
  const t = useT();
  const locale = useLocale();
  return (
    <small>
      {t("AMOUNT_EXCL_TAX", "$1 HT", [euros(article.priceExclTax, locale)])}
      {article.vat > 0 && ` · ${t("VAT_RATE", "TVA $1 %", [article.vat])}`}
    </small>
  );
}
